import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../../redux/hooks';

interface ProtectedRoutesProps {
  children: React.ReactNode;
  redirectTo: string;
}

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ children, redirectTo }) => {
  const { userData } = useAppSelector((state: any) => state.user);
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to={'login'} replace />;
  }

  if (userData && userData?.IsOnBoardingProcess === true && window.location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoutes;
